import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Franchise, newFranchise } from '../models/franchise';

interface State {
    franchise: Franchise,
}

const initialState: State = {
    franchise: { ...newFranchise }
};

export const editFranchiseSlice = createSlice({
    name: 'editFranchise',
    initialState,
    reducers: {
        update(state, action: PayloadAction<Partial<Franchise>>) {
            state.franchise = { ...state.franchise, ...action.payload };
        },
    }
});
